import { Injectable } from '@angular/core';
import {
    emptyIqMcModalMci,
    emptyIqMcModalSection,
    IIqMcModalMci,
    IIqMcModalMciSection,
    IIqMcModalStateService,
    iqMcModalFooterSection,
    iqMcModalPrimarySection,
    iqMcModalSecondarySection,
    iqMcModalTitle,
    iqMcXmaModalTitle,
} from '../../models';
import { emptyDatiqModal, IDatiqModal } from '@dat/datiq-components-pkg/modal';

@Injectable({
    providedIn: 'root',
})
export class IqMcModalStateService implements IIqMcModalStateService {
    constructor() {}
    mapXmaModalSettings(): IDatiqModal {
        return {
            ...emptyDatiqModal,
            title: iqMcXmaModalTitle,
        };
    }

    mapMciModalSettings(): IIqMcModalMci {
        const modalSettings: IDatiqModal = {
            ...emptyDatiqModal,
            title: iqMcModalTitle,
        };
        const title: string = iqMcModalTitle;
        const primarySection: IIqMcModalMciSection =
            this.mapMciModalPrimarySection();
        const secondarySection: IIqMcModalMciSection =
            this.mapMciModalSecondarySection();
        const footerSection: IIqMcModalMciSection =
            this.mapMciModalFooterSection();
        return {
            ...emptyIqMcModalMci,
            title,
            primarySection,
            secondarySection,
            footerSection,
            modalSettings,
        };
    }

    mapMciModalPrimarySection(): IIqMcModalMciSection {
        return { ...emptyIqMcModalSection, ...iqMcModalPrimarySection };
    }

    mapMciModalSecondarySection(): IIqMcModalMciSection {
        return { ...emptyIqMcModalSection, ...iqMcModalSecondarySection };
    }

    mapMciModalFooterSection(): IIqMcModalMciSection {
        return { ...emptyIqMcModalSection, ...iqMcModalFooterSection };
    }
}
